import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';

import { InputContainer, Prefix, StyledInput } from './styles';

type InvekosNumberInputProps = {
  value?: string;
  onValidNumber?: (number: string) => void;
  onInvalidNumber?: () => void;
  readonly?: boolean;
};

const formatInvekosNumber = (input: string): string => {
  const digitsOnly = input.replace(/\D/g, '');

  const trimmed = digitsOnly.slice(0, 12);

  if (trimmed.length >= 3) {
    return trimmed.replace(
      /(\d{2})?(\d{3})?(\d{3})?(\d{4})?/,
      (_, p2, p3, p4, p5) => {
        return [p2, p3, p4, p5].filter(Boolean).join(' ');
      }
    );
  }

  return trimmed;
};

const InvekosNumberInput: React.FC<InvekosNumberInputProps> = ({
  value,
  onValidNumber,
  onInvalidNumber,
  readonly = false,
}) => {
  const [displayValue, setDisplayValue] = useState('');
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (value) {
      setDisplayValue('276 ' + formatInvekosNumber(value.slice(3)));
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const formatted = formatInvekosNumber(newValue);
    setDisplayValue(formatted);

    const digitsOnly = formatted.replace(/\D/g, '');
    if (digitsOnly.length === 12 && onValidNumber) {
      onValidNumber('276' + digitsOnly);
      setIsValid(true);
    } else {
      onInvalidNumber();
    }
  };

  const handleBlur = () => {
    const digitsOnly = displayValue.replace(/\D/g, '');
    setIsValid(digitsOnly.length === 12);
  };

  if (readonly) {
    return (
      <Box>
        <TextField
          disabled={true}
          sx={{ fontFamily: 'monospace' }}
          value={displayValue}
        />
      </Box>
    );
  }

  return (
    <Box>
      <InputContainer>
        <Prefix>276</Prefix>
        <StyledInput
          isValid={isValid}
          type="text"
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="__ ___ ___ ____"
        />
      </InputContainer>
    </Box>
  );
};

export default InvekosNumberInput;
